import React from 'react';
import './OrdenarPor.css';

const OPCIONES = [
  { valor: 'relevante', etiqueta: 'Relevantes' },
  { valor: 'menor-precio', etiqueta: 'Menor precio' },
  { valor: 'mayor-precio', etiqueta: 'Mayor precio' },
];

/**
 * Controlled sort selector. `onOrdenar` defaults to a no-op so mounting it
 * without a handler can never throw.
 */
const OrdenarPor = ({ valor = 'relevante', onOrdenar = () => {} }) => (
  <div className="ordenar-por-container">
    <label className="ordenar-por-etiqueta" htmlFor="ordenar-por">
      Ordenar por
    </label>
    <select
      id="ordenar-por"
      value={valor}
      onChange={(e) => onOrdenar(e.target.value)}
    >
      {OPCIONES.map((o) => (
        <option key={o.valor} value={o.valor}>{o.etiqueta}</option>
      ))}
    </select>
  </div>
);

export default OrdenarPor;
